import { defineStore } from "pinia";

export const useDashboardStore = defineStore("dashboard", {
  state: () => ({
    filterName: "" as string,
    filterAssignee: "all" as string,
    filterStateOption: null as string | null,
    sortDesc: false as boolean,
    sortBy: "priority" as string,
  }),
  actions: {
    setFilterName(val: string) {
      this.filterName = val;
    },
    setFilterAssignee(val: string) {
      this.filterAssignee = val;
    },
    setFilterStateOption(val: string | null) {
      this.filterStateOption = val;
    },
    setSortDesc(val: boolean) {
      this.sortDesc = !!val;
    },
    setSortBy(val: string) {
      this.sortBy = val;
    },
  },
});

export default useDashboardStore;
